import { PhoneNumberSchema } from "@redotech/redo-common-model/phone/phone-number";
import * as z from "zod";

export const getPhoneNumberForTeam = {
  name: "getPhoneNumberForTeam" as const,
  input: z.object({}),
  output: PhoneNumberSchema.nullable(),
};
